"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePowerMonitorService = void 0;
const mutations_1 = require("../graphql/mutations");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
function usePowerMonitorService() {
    const requestService = async (params) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.requestPowerMonitorService,
                variables: { input: params },
            });
            return response.data?.requestPowerMonitorService;
        }
        catch (error) {
            console.error('Error requesting power monitor service:', error);
            throw error;
        }
    };
    const clearAlert = async (sensorId, hubId) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.clearPowerMonitorAlert,
                variables: { sensorId, hubId },
            });
            return response.data?.clearPowerMonitorAlert;
        }
        catch (error) {
            console.error('Error clearing power monitor alert:', error);
            throw error;
        }
    };
    return {
        requestService,
        clearAlert,
    };
}
exports.usePowerMonitorService = usePowerMonitorService;
exports.default = usePowerMonitorService;
